import { render, staticRenderFns } from "./upload-project-logo.vue?vue&type=template&id=56156458&scoped=true&"
import script from "./upload-project-logo.vue?vue&type=script&lang=js&"
export * from "./upload-project-logo.vue?vue&type=script&lang=js&"
import style0 from "./upload-project-logo.vue?vue&type=style&index=0&id=56156458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56156458",
  null
  
)

export default component.exports